export default __webpack_public_path__ + "static/media/harvest.ec5d8a1d.svg";